module.exports = __webpack_public_path__ + "img/map_tools_stack.e464c071.svg";